module.exports = "/img/3.cf62e3.webp";